module.exports = __webpack_public_path__ + "43d87cc21ea6eb706622438e2eb1368d.pdf";